module.exports = __webpack_public_path__ + "static/media/KUZMA CAR-50.05bc6568.png";